import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'
import DashboardContent from "../components/dashboard/DashboardContent";
import Header from '../components/common/Header';
import { useEffect, useRef } from 'react';
import { validateLogin } from '../services/validate-login';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    validateLogin(navigate);
  }, []);
  return (
    <>
      <div className="min-h-full">
        <Header title="Dashboard"/>
        {/* <header className="bg-white shadow">
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900">Documents</h1>
          </div>
        </header> */}
        <main>
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <DashboardContent />
          </div>
        </main>
      </div>
    </>
  )
}
